import { trackTask } from "src/utils/monitoring/events/tasks";
import { registerHandler } from "../handler";
import { generateEventId } from "../utils";
import { send } from "src/utils/fetch";
import { LibCategories, waitForConsent } from "src/utils/consent";
import { appConfig } from "src/config";

declare const rdt: any;

const isTestEnv = appConfig.NOOM_ENV !== "production";

export default function registerHandlers() {
  registerHandler("lead", async () => {
    waitForConsent([LibCategories.targetingCookies]).then(async () => {
      const task = trackTask("trackRedditLead");
      const eventName = "Lead";
      try {
        task.start();
        const conversionId = generateEventId();
        rdt("track", eventName, {
          conversionId,
        });
        const eventData = {
          event_name: eventName,
          event_id: conversionId,
          test_mode: isTestEnv,
        };
        await send("POST", `/pixel/v1/i/redditCapiPixel/`, eventData);
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });

  registerHandler("purchase", async ({ order }) => {
    waitForConsent([LibCategories.targetingCookies]).then(async () => {
      const task = trackTask("trackRedditPurchase");
      try {
        task.start();
        const conversionId = generateEventId();
        const eventName = "SignUp";
        rdt("track", eventName, {
          value: order.eltv_13_months,
          currency: "USD",
          conversionId,
        });
        const eventData = {
          event_name: eventName,
          event_id: conversionId,
          currency: "USD",
          value: order.eltv_13_months,
          test_mode: isTestEnv,
        };
        await send("POST", `/pixel/v1/i/redditCapiPixel/`, eventData);
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });

  registerHandler("purchaseIntent", async ({ estimatedValue }) => {
    waitForConsent([LibCategories.targetingCookies]).then(async () => {
      const task = trackTask("trackRedditPurchaseIntent");
      try {
        task.start();
        const conversionId = generateEventId();
        const eventName = "Purchase";
        rdt("track", eventName, {
          value: estimatedValue,
          currency: "USD",
          conversionId,
        });
        const eventData = {
          event_name: eventName,
          event_id: conversionId,
          currency: "USD",
          value: estimatedValue,
          test_mode: isTestEnv,
        };
        await send("POST", `/pixel/v1/i/redditCapiPixel/`, eventData);
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });
}
